import type { OneTimeProduct, AssertProduct } from '@/store/products'

declare const _prd_BLkhQaZ9ZapP: {
	id: 'prd_BLkhQ2DEV2aZ9ZapP'
	ident: 'prd_BLkhQaZ9ZapP'
	sku: 'simple_workbook_bundle_48_usd'
	type: 'one_time'
	price: {
		price_id: 'prc_RPbxd2DEV23KbrnCp'
		amount: 90
		amount_usd: 48
		currency: 'USD'
		amount_with_discount: 48
		discount: 42
		promocode: 'BASE'
	}
}
type _check = AssertProduct<typeof _prd_BLkhQaZ9ZapP, OneTimeProduct>
const prd_BLkhQaZ9ZapP = { ident: 'prd_BLkhQaZ9ZapP' } as typeof _prd_BLkhQaZ9ZapP

export default prd_BLkhQaZ9ZapP
